"use strict";

var _defineProperty = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _asyncToGenerator = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlvyWidget = exports.OlvyUtils = void 0;
var _react = require("react");
var _window;
var OlvyUtils = exports.OlvyUtils = (_window = window) === null || _window === void 0 ? void 0 : _window.OlvyUtils;
var OlvyWidget = /*#__PURE__*/function (_react$Component) {
  _inherits(OlvyWidget, _react$Component);
  function OlvyWidget(props) {
    var _this;
    _classCallCheck(this, OlvyWidget);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(OlvyWidget).call(this, props));
    _this.state = {
      scriptLoaded: false
    };
    return _this;
  }
  _createClass(OlvyWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadScript();
    }
  }, {
    key: "loadScript",
    value: function () {
      var _loadScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var foundOlvyInstance, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              if (!window) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.getOlvyUtils();
            case 1:
              exports.OlvyUtils = OlvyUtils = _context.v;
              // if workspace alias, initialize
              if (this.props.config.workspaceAlias && window.Olvy) {
                foundOlvyInstance = window.OlvyInstances.find(function (instance) {
                  return instance.workspaceAlias === _this2.props.config.workspaceAlias;
                }); // if olvyInstance not found, we create one
                if (!foundOlvyInstance) {
                  new window.Olvy(this.props.config.workspaceAlias, _objectSpread(_objectSpread({}, this.props.config.options), {}, {
                    widgetId: this.props.config.widgetId
                  }));
                }
              }
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log(_t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 3]]);
      }));
      function loadScript() {
        return _loadScript.apply(this, arguments);
      }
      return loadScript;
    }()
  }, {
    key: "getLoadedOlvyScript",
    value: function getLoadedOlvyScript() {
      var olvyScript = document.getElementById("olvyScriptV2");
      if (olvyScript) {
        return olvyScript;
      } else {
        return null;
      }
    }
  }, {
    key: "getOlvyUtils",
    value: function () {
      var _getOlvyUtils = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window2, _window3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!((_window2 = window) !== null && _window2 !== void 0 && _window2.OlvyUtils)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, window.OlvyUtils);
            case 1:
              _context2.n = 2;
              return this.olvyScriptLoader();
            case 2:
              return _context2.a(2, (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.OlvyUtils);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getOlvyUtils() {
        return _getOlvyUtils.apply(this, arguments);
      }
      return getOlvyUtils;
    }()
  }, {
    key: "olvyScriptLoader",
    value: function () {
      var _olvyScriptLoader = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2, new Promise(function (resolve, reject) {
                var _window4;
                if (!((_window4 = window) !== null && _window4 !== void 0 && _window4.OlvyUtils)) {
                  var createdOlvyScript = _this3.getLoadedOlvyScript();

                  // if script isn't already created by some other olvy-widget, we create one
                  if (!createdOlvyScript) {
                    var script = document.createElement("script");
                    script.id = "olvyScriptV2";
                    script.src = "https://app.olvy.co/scriptV2.js";
                    script.onload = function () {
                      var _window5;
                      _this3.setState({
                        scriptLoaded: true
                      });
                      exports.OlvyUtils = OlvyUtils = (_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.OlvyUtils;

                      // Call the callback function when OlvyUtils is loaded
                      if (OlvyUtils && _this3.props.onOlvyUtilsLoad) {
                        _this3.props.onOlvyUtilsLoad(OlvyUtils);
                      }

                      // The script is loafded, so resolve the Promise
                      resolve(true);
                    };
                    script.onerror = function () {
                      // There was an error loading the script, so reject the Promise
                      reject(new Error("Failed to load script."));
                    };
                    document.body.appendChild(script);
                  } else {
                    // script was already created, just listen for onload
                    createdOlvyScript.onload = function () {
                      var _window6;
                      _this3.setState({
                        scriptLoaded: true
                      });
                      exports.OlvyUtils = OlvyUtils = (_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.OlvyUtils;

                      // Call the callback function when OlvyUtils is loaded
                      if (OlvyUtils && _this3.props.onOlvyUtilsLoad) {
                        _this3.props.onOlvyUtilsLoad(OlvyUtils);
                      }

                      // The script is loaded, so resolve the Promise
                      resolve(true);
                    };
                    createdOlvyScript.onerror = function () {
                      // There was an error loading the script, so reject the Promise
                      reject(new Error("Failed to load script."));
                    };
                  }
                } else {
                  resolve(true);
                }
              }));
          }
        }, _callee3);
      }));
      function olvyScriptLoader() {
        return _olvyScriptLoader.apply(this, arguments);
      }
      return olvyScriptLoader;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.props.targetElement;
    }
  }]);
  return OlvyWidget;
}(_react.Component);
exports.OlvyWidget = OlvyWidget;